import {LegacyContactInfoAdaptor} from './legacyContactInfoAdaptor.js';

export var LegacyInviterAdaptor = function(inviterData, person) {
    var inviter = {};
    
    // Constructor
    if (inviterData) {
        inviter.personID = inviterData.id;
        inviter.firstName = inviterData.names.getAName().given;
        inviter.lastName = inviterData.names.getAName().family;
        inviter.preferredName = inviterData.preferredName;
        inviter.profileThumbnailUrl = inviterData.profileThumbnailUrl;
        inviter.contactInfo = LegacyContactInfoAdaptor(person);
    }

    // -----------------------------------------------------
    //
    //                 Public Methods
    //
    // -----------------------------------------------------

    // -----------------------------------------------------
    //
    //                 Private Methods
    //
    // -----------------------------------------------------

    return inviter;
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/models/adaptors/legacyInviterAdaptor.js
// module id = 197
// module chunks = 0